// Responsive images: uploaded photos are served resized and in WebP by the server
// (/img/<width>/<file>, see server/src/images.js). SVGs and other URLs are left as they are.
const WIDTHS = [96, 160, 240, 320, 480, 640, 960, 1280];

const resizable = (src) => typeof src === 'string' && /^\/uploads\/[^/]+\.(png|jpe?g|webp|gif)$/i.test(src);

export function imgUrl(src, width) {
  if (!resizable(src)) return src;
  const w = WIDTHS.find((x) => x >= width) || WIDTHS[WIDTHS.length - 1];
  return `/img/${w}/${src.slice('/uploads/'.length)}`;
}

// Props for <img>: `sizes` is how wide the image shows (CSS), `max` the largest width worth sending.
//   <img {...responsive(p.images[0], '(min-width: 1024px) 25vw, 50vw', 640)} alt="" />
export function responsive(src, sizes, max = 1280) {
  if (!resizable(src)) return { src };
  const widths = WIDTHS.filter((w) => w <= max);
  return {
    src: imgUrl(src, max),
    srcSet: widths.map((w) => `${imgUrl(src, w)} ${w}w`).join(', '),
    sizes,
  };
}
